var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11856",
    "data-name": "Group 11856",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.043,
    height: 14.574,
    viewBox: "0 0 16.043 14.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16873",
    "data-name": "Rectangle 16873",
    width: 16.043,
    height: 14.574,
    fill: "#ee7d11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11855",
    "data-name": "Group 11855",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37772",
    "data-name": "Path 37772",
    d: "M1.213,13.356h.369q6.816,0,13.632,0a1.339,1.339,0,0,1,.418.052.584.584,0,0,1,.385.633.594.594,0,0,1-.529.52,2.362,2.362,0,0,1-.275.01H.8c-.05,0-.1,0-.15,0A.6.6,0,0,1,0,13.911Q0,7.283,0,.655A.6.6,0,0,1,.6,0a.6.6,0,0,1,.607.674q0,4.661,0,9.322v3.36",
    transform: "translate(0 0)",
    fill: "#ee7d11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37773",
    "data-name": "Path 37773",
    d: "M59.916,36.428l3.523-3.553c-.09,0-.176-.012-.262-.012-.869,0-1.737,0-2.606,0a1.288,1.288,0,0,1-.346-.041.583.583,0,0,1-.414-.565.577.577,0,0,1,.4-.571,1.441,1.441,0,0,1,.4-.046q2.08,0,4.16,0c.606,0,.808.205.808.813q0,2.142,0,4.285a.612.612,0,0,1-.463.657.6.6,0,0,1-.747-.617c-.007-.894,0-1.787,0-2.681,0-.09,0-.179,0-.34-.115.1-.186.165-.252.231L60.51,37.573c-.45.448-.716.448-1.163,0-.383-.384-.763-.771-1.168-1.18-.093.089-.17.159-.244.233l-4.589,4.588c-.047.047-.093.1-.143.141a.606.606,0,1,1-.847-.866c.769-.779,1.545-1.55,2.319-2.323L57.6,35.242c.429-.429.712-.43,1.146.005.388.389.774.78,1.172,1.181",
    transform: "translate(-49.538 -30.05)",
    fill: "#ee7d11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstGraph);
export default __webpack_public_path__ + "static/media/firstGraph.07ce933994a088e084ce3764d8955f1e.svg";
export { ForwardRef as ReactComponent };